export default "__VITE_ASSET__CIu8OHnD__"